import script from "./productPage.vue?vue&type=script&setup=true&lang=js"
export * from "./productPage.vue?vue&type=script&setup=true&lang=js"

import "./productPage.vue?vue&type=style&index=0&id=73d6c3a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73d6c3a9"]])

export default __exports__